import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Fill-in-the-Blank Question Component
 */
export function FillInQuestion({ question, value, onChange, disabled = false, showCorrect = false }) {
  const isCorrect = showCorrect && value.trim().toLowerCase() === question.correctAnswer.trim().toLowerCase();
  const isIncorrect = showCorrect && value && !isCorrect;

  return (
    <div className="fill-in-question">
      <Form.Group>
        <Form.Control
          type="text"
          placeholder="Type your answer here..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className={showCorrect ? (isCorrect ? 'is-valid' : isIncorrect ? 'is-invalid' : '') : ''}
        />
        {showCorrect && isCorrect && (
          <Form.Control.Feedback type="valid">
            Correct!
          </Form.Control.Feedback>
        )}
        {showCorrect && isIncorrect && (
          <Form.Control.Feedback type="invalid">
            Incorrect. The correct answer is: {question.correctAnswer}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </div>
  );
}
